/** @jsxImportSource @emotion/react */

import React from 'react';
import Help from '@component/iyagigo/hub/help';
import PageTemplate from '@page/iyagigo/page-template';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { useNavigate } from 'react-router-dom';

const HelpPage: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <PageTemplate
      title='도움말'
      mode={'back'}
      handleNavigationClick={() => navigate(IYAGIGO_PATH.HUB_HOME_PATH)}>
      <Help />
    </PageTemplate>
  );
};

export default HelpPage;
